<div class="bmc-job-settings">
  <div class="bmc-job-settings__top-section">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.NAME' | translate}}</h5>
      <ng-container *ngIf="isDevelopment; else editName">
        <h5>{{currentJob.name}}</h5>
      </ng-container>
      <ng-template #editName>
        <input 
          type="text" 
          [(ngModel)]="currentJob.name" 
          class="bmc-job-settings__input" 
          [disabled]="currentJob.disableEditJob"
          [ngClass]="{ 'valid': isValidCurrentJobName, 'invalid': isValidCurrentJobName === false }"
          (input)="validateInputJobName($event)"
          maxlength="24"
        />
      </ng-template>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.CREATION_DATE' | translate}}</h5>
  <h5>{{ currentJob.creationDate | userTimezoneFormat:10 }}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__top-section bmc-job-settings__top-section-second">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_NUMBER' | translate}}</h5>
      <h5>{{currentJob.radNumber}}</h5>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_ID' | translate}}</h5>
      <h5>{{currentJob.idCase}}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__middle-section">
    <div class="bmc-job-settings__middle-section__left">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.DESCRIPTION' | translate}}</h5>
      <ng-container *ngIf="isDevelopment; else editDesc">
        <h5 class="bmc-job-settings__middle-section__left__text">{{currentJob.description}}</h5>
      </ng-container>
      <ng-template #editDesc>
        <input 
          type="text" 
          [(ngModel)]="currentJob.description" 
          class="bmc-job-settings__input" 
          [disabled]="currentJob.disableEditJob" 
        />
      </ng-template>
    </div>
  </div>
  <div class="bmc-job-settings__enable mt">
    <bzg-switch [(ngModel)]='currentJob.enabled' [disabled]="currentJob.disableEditJob === true"></bzg-switch>
    <h5 class="bmc-job-settings__enable__text">{{ 'GLOBAL.ENABLED' | translate}}</h5>
  </div>
  <div class="bmc-job-settings__enable mt" *ngIf="shouldShowSwitch()">
    <bzg-switch [(ngModel)]="jobStates[currentJob.guid].rescheduleJob" (ngModelChange)="checkAndSetDate()"></bzg-switch>
    <h5 class="bmc-job-settings__enable__text">{{ 'JOBS.RESCHEDULE_JOB' | translate}}</h5>
  </div>
  <div *ngIf="shouldShowDateSection()" class="bmc-job-settings__date-section bz-space--stack-m">
    <h5 class="bz-font-weight--semibold">{{'JOBS.NEXT_RUN_TIME' | translate}}</h5>
    <div class="bmc-job-settings">
      <div class="bmc-job-settings__date-section__bottom">
        <bz-date-time-picker
          [currentDate]="jobStates[currentJob.guid].nextRuntimeDate"
          [dateMax]="dateMax"
          [isDisabled]="currentJob.disableEditJob"
          (valueChange)="onDateChange($event)">
        </bz-date-time-picker>
        <div class="bmc-job-settings__date-section__bottom">
          <bzg-button-primary [disabled]="currentJob.disableEditJob" (click)="setJobNow()">{{'JOBS.SET_JOB_NOW' |
            translate}}</bzg-button-primary>
        </div>
      </div>
      <!-- Warning message for past dates -->
      <div *ngIf="showPastDateWarning && !currentJob.disableEditJob" class="bmc-job-settings__warning">
        <div class="bmc-job-settings__warning-content">
          <bzg-icon [nameIcon]="'warning'" [size]="20" class="bz-space--inline-xs bz-icon-color--warning"></bzg-icon>
          <div class="bmc-job-settings__warning-text">
            {{ 'JOBS.PAST_DATE_WARNING' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="" *ngIf="showReset">
    <h5 class="bz-font-weight--semibold">{{'JOBS.RESET_DEVELOP_TITLE' | translate}}</h5>
    <div class="bz-form-message__text">{{'JOBS.RESET_DEVELOP' | translate}} <a class="bmc-job-settings__reset--link"
        (click)="resetJob()">{{ 'GLOBAL.RESET' | translate}}</a>
    </div>
  </div>
</div>

<job-form-buttons
  [validationMessage]="validationMessage"
  [showValidationMessage]="showValidationMessage"
  [applyDisabled]="applyDisabled"
  [currentJobDisableEdit]="currentJob.disableEditJob"
  (apply)="applyChanges()"
  (cancel)="cancelChanges()">
</job-form-buttons>